import { Paragraph } from '@purpurds/purpur';
import { TeliaCardFrameLink, TeliaContentBanner, TeliaHeading } from '@teliads/components/react';
import { ReactNode } from 'react';

import { defaultContentCardsImage } from 'components/custom/card-display-variants/ContentCards';
import { createMultipleSizeImages, Dimensions } from 'utils/utils';

type Props = {
  url: string;
  title: string;
  body: ReactNode;
  image?: {
    url: string;
    altText: string;
    focusArea?: string;
  };
};

const MediumWhiteCard = ({ url, title, image, body }: Props) => {
  const dimensions: Dimensions = {
    small: ['21:9', 200],
    medium: ['21:9', 250],
    large: ['4:3', 400],
  };
  const img = image && image.url;

  return (
    <TeliaCardFrameLink href={url} disablePadding key={title}>
      <TeliaContentBanner
        imgSrc={
          img ? createMultipleSizeImages(image, dimensions).large : defaultContentCardsImage.url
        }
        imgAlt={
          img
            ? createMultipleSizeImages(image, dimensions).altText
            : defaultContentCardsImage.altText
        }
        smallSet={
          img ? createMultipleSizeImages(image, dimensions).small : defaultContentCardsImage.url
        }
        mediumSet={
          img ? createMultipleSizeImages(image, dimensions).small : defaultContentCardsImage.url
        }
        data-testid="telia-content-banner"
      >
        <div className="collection-list__text-wrapper">
          <TeliaHeading variant="title-300" tag="h3">
            {title}
          </TeliaHeading>
          {body && (
            <Paragraph className="collection-list__item-text" variant="paragraph-100">
              {body}
            </Paragraph>
          )}
        </div>
      </TeliaContentBanner>
    </TeliaCardFrameLink>
  );
};

export default MediumWhiteCard;
